import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  activeCurrency,
  createCurrency,
  deleteCurrency,
  getCurrency,
  inactiveCurrency,
  listCurrency,
  updateCurrency,
} from 'api/setting/currency/currency.api';
import {
  ActiveCurrencyRequestModel,
  DeleteCurrencyRequestModel,
  GetCurrencyRequestModel,
  InactiveCurrencyRequestModel,
  ListCurrencyRequestModel,
  SaveCurrencyRequestModel,
} from 'models/setting/currency/currency.model';

export const getCurrencyAction = createAsyncThunk(
  'GET_MESSAGE_TEMPLATE_REQUEST',
  async (payload: GetCurrencyRequestModel) => getCurrency(payload),
);

export const listCurrencyAction = createAsyncThunk(
  'LIST_MESSAGE_TEMPLATE_REQUEST',
  async (payload: ListCurrencyRequestModel) => listCurrency(payload),
);

export const createCurrencyAction = createAsyncThunk(
  'CREATE_MESSAGE_TEMPLATE_REQUEST',
  async (payload: SaveCurrencyRequestModel, { rejectWithValue }) => {
    try {
      return await createCurrency(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const updateCurrencyAction = createAsyncThunk(
  'UPDATE_MESSAGE_TEMPLATE_REQUEST',
  async (payload: SaveCurrencyRequestModel, { rejectWithValue }) => {
    try {
      return await updateCurrency(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const deleteCurrencyAction = createAsyncThunk(
  'DELETE_MESSAGE_TEMPLATE_REQUEST',
  async (payload: DeleteCurrencyRequestModel, { rejectWithValue }) => {
    try {
      return await deleteCurrency(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const inactiveCurrencyAction = createAsyncThunk(
  'INACTIVE_MESSAGE_TEMPLATE_REQUEST',
  async (payload: InactiveCurrencyRequestModel, { rejectWithValue }) => {
    try {
      return await inactiveCurrency(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const activeCurrencyAction = createAsyncThunk(
  'ACTIVE_MESSAGE_TEMPLATE_REQUEST',
  async (payload: ActiveCurrencyRequestModel, { rejectWithValue }) => {
    try {
      return await activeCurrency(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);
